import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskLiveChatMyChatsRoute } from '@atlassian/jira-router-routes-servicedesk-live-chat-routes/src/servicedeskLiveChatMyChatsRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import LiveChatMyChats, { LazyLiveChatMyChats } from './ui/my-chats/index.tsx';

export const servicedeskLiveChatMyChatsRouteEntry = createEntry(
	servicedeskLiveChatMyChatsRoute,
	() => ({
		group: 'servicedesk',
		component: LiveChatMyChats,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},

		resources: [...getServiceDeskNavigationResources(), getConsolidationStateResource()],

		forPaint: [LazyAtlassianNavigation, LazyLiveChatMyChats],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-live-chat-entries/src/servicedeskLiveChatMyChatsRouteEntry.tsx',
				whichExportToUse: 'servicedeskLiveChatMyChatsRouteEntry',
			},

			enabled: true,
		},
	}),
);
